<div class="app-container">
  <page-header [icon]="'far-list-alt'" [title]="'stock.load'" [isStockOperation]="true">
    <ng-container class="header-btn">
      <div class="flex-gap-5 align-items-center">
        <modal-stock-operation-card
          #modalStockOperation
          [moves]="operations"
          [hideButton]="true"
          [alwaysLoadSelectData]="true"
          [isCreatingProduct]="false"
          [producers]="queryProducers.data()"
          [vats]="queryVats.data()"
          [depotFrom]="selectedDepotFrom()"
          [depotTo]="selectedDepotTo"
          [type]="selectedOperationType"
          [depots]="queryDepotsOptions.data()"
          [suppliers]="querySuppliers.data()"
          (result)="operationListChange($event)"
        >
        </modal-stock-operation-card>
        <!--        TODO: finalize EAN printing-->
        @if (operations?.length) {
          <btn
            [label]="isPrintingEANs ? 'back' : 'product.tab.barcode'"
            [title]="isPrintingEANs ? ('back' | translate) : ('product.tab.barcode' | translate)"
            [icon]="isPrintingEANs ? 'far-list' : 'far-sticky-note'"
            [classes]="['btn-third', 'float-right', 'me-2']"
            data-cy="print-labels"
            (onEvent)="isPrintingEANs = !isPrintingEANs"
          ></btn>
        }
        @if (!areCoreDataLoading() && operations?.length) {
          <btn
            [label]="
              selectedOperationType === 'in'
                ? 'product.load'
                : selectedOperationType === 'out'
                  ? 'product.unload'
                  : 'product.transfer'
            "
            [title]="
              selectedOperationType === 'in'
                ? ('product.load' | translate)
                : selectedOperationType === 'out'
                  ? ('product.unload' | translate)
                  : ('product.transfer' | translate)
            "
            [icon]="
              selectedOperationType === 'in'
                ? 'far-layer-plus'
                : selectedOperationType === 'out'
                  ? 'far-layer-minus'
                  : 'far-layer-minus'
            "
            [classes]="[
              selectedOperationType === 'in'
                ? 'btn-first-green'
                : selectedOperationType === 'out'
                  ? 'btn-first-red'
                  : 'btn-first-orange',
              'btn-sm'
            ]"
            (onEvent)="createStockLoad()"
            data-cy="submit-stock-form"
          >
          </btn>
        }
      </div>
      @if (!queryDepotsOptions.isFetching() && !queryDepotsOptions.isPending()) {
        <div class="row d-flex flex-gap-10 ml-0">
          @if (selectedOperationType !== 'in') {
            <div>
              <div class="form-group mb-0 flex-gap-5 align-items-center">
                <label class="mb-0 text-nowrap">{{ 'depot.from' | translate }}:</label>
                <!--              todo (pointerdown)="onPointerDown($event)"-->
                <form-row-select
                  [title]="'depotSelectFrom'"
                  [icon]="null"
                  [model]="selectedDepotFrom()"
                  (modelChange)="selectedDepotFromChanged($event)"
                  [options]="queryDepotsOptions.data()"
                  [dataCyAttribute]="'select-depot-from'"
                ></form-row-select>
              </div>
            </div>
          }
          @if (selectedOperationType === 'in' || selectedOperationType === 'transfer') {
            <div>
              <div class="form-group mb-0 flex-gap-5 align-items-center">
                <label class="mb-0 text-nowrap">{{ 'depot.to' | translate }}:</label>
                <!--            (pointerdown)="onPointerDown($event)" todo-->
                <form-row-select
                  [title]="'depotSelectTo'"
                  [icon]="null"
                  [model]="selectedDepotTo"
                  (modelChange)="selectedDepotToChanged($event)"
                  [options]="queryDepotsOptions.data()"
                  [dataCyAttribute]="'select-depot'"
                ></form-row-select>
              </div>
            </div>
          }
        </div>
      }
    </ng-container>
    <ng-container class="stock-operation-buttons">
      <div class="operation-type-wrap">
        @for (type of operationTypes; track type) {
          <btn
            [label]="type"
            data-cy="nav-button"
            [dataCyAttribute]="'nav-button-' + type"
            [title]="type | translate"
            [btnDisabled]="!!operations?.length"
            (onEvent)="setOperationType(type)"
            [classes]="[selectedOperationType === type ? 'btn btn-white-selected' : 'btn btn-white']"
          ></btn>
        }
      </div>
    </ng-container>
  </page-header>
  <!-- Global Serial Numbers Modal used by the queue (opened programmatically).
  Keep it in the DOM so the instance exists, but hide its inline open button. -->
  <app-modal-serial-numbers
    #serialNumbersGlobal
    [isCreatingProductMovePack]="true"
    [hideOpenButton]="true"
    (serialNumbersChanged)="persistCurrentSerialNumbersDraft($event)"
  >
  </app-modal-serial-numbers>
  <div class="container-fluid">
    <div class="row cards-responsive">
      <div class="col-12 col-sm-12 col-1100 col-lg-6 col-xl-6 ps-0">
        @if (!isPrintingEANs) {
          <div class="card mb-0">
            @if (!isPrintingEANs && selectedOperationType === 'in') {
              <div class="row">
                <div class="col d-flex align-self-center">
                  <div class="card-title">
                    {{ 'product.search' | translate }}
                  </div>
                </div>
                <div class="col mt-md-1 d-flex justify-content-end">
                  <modal-batch-import-from-file
                    class="me-2"
                    [depotTo]="selectedDepotTo"
                    [suppliers]="querySuppliers.data()"
                    [isCreatingProducts]="true"
                    (resultBatch)="createBatchFromFile($event)"
                  ></modal-batch-import-from-file>
                </div>
              </div>
            }
            <div class="row">
              <div class="col-12 col-sm-12">
                <div class="form-group ps-0 pe-0 ml-0 mr-0 pt-2">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="searchFulltext"
                      (keydown)="filterKeyDown($event)"
                      data-cy="search-product-fulltext"
                    />
                    <div class="input-group-btn">
                      <button
                        type="button"
                        class="btn-search"
                        (click)="queryProducts.refetch()"
                        [title]="'filter' | translate"
                      >
                        <i class="far fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (!products || !products().length) {
              <div class="row" [ngClass]="{ h150: !products()?.length }">
                <div class="col-12">
                  <loading-spinner [isLoading]="areCoreDataLoading()" [classesString]="'top-50'"></loading-spinner>
                </div>
              </div>
            }
            @if (selectedOperationType !== 'in' && !areCoreDataLoading() && !selectedDepotFrom()) {
              <div class="text-center">
                {{ 'depot.select' | translate }}
              </div>
            }
            @if (!products()?.length && !queryProducts.isFetching() && !areCoreDataLoading()) {
              <div class="margin text-center" style="padding: 1.625rem">
                {{ 'no.items' | translate }}
              </div>
            }
            @if (showAvailabilityWarning && !queryProducts.isFetching() && !areCoreDataLoading()) {
              <div class="margin text-center" style="padding: 1.625rem">
                {{ 'no.items.check.availability.warning' | translate }}
              </div>
            }
            @if (selectedOperationType !== 'transfer' && (selectedOperationType === 'in' || selectedDepotFrom())) {
              <div class="row prod-list-scrolling">
                <div class="col">
                  <div class="tableWrapper">
                    <table
                      class="table table-responsive"
                      [ngClass]="{ h150: !products()?.length && areCoreDataLoading() }"
                    >
                      <loading-spinner
                        [isLoading]="queryProducts.isFetching()"
                        [classesString]="'pt-0'"
                      ></loading-spinner>
                      @if (products()?.length) {
                        <div>
                          <thead>
                            <tr>
                              <th class="ps-0">{{ 'product.name' | translate }}</th>
                              @if (selectedOperationType === 'transfer') {
                                <th class="text-center fixed-column-width">
                                  {{ ('product.expirationDate' | translate) + ', ' + ('product.batch' | translate) }}
                                </th>
                              }
                              <th class="text-center fixed-column-width">{{ 'products.availability' | translate }}</th>
                              <th class="fixed-column-width"></th>
                            </tr>
                          </thead>
                          @if (selectedOperationType !== 'transfer') {
                            <tbody class="images" [photoGalleryGroup]="{ index: 1 }">
                              @for (prod of products(); track prod) {
                                <tr>
                                  <td class="ps-1 custom-product-td" [ngClass]="{ 'disabled-product': !prod.enabled }">
                                    <div class="flex-gap-10 align-items-center">
                                      <div
                                        [photoGallery]="prod.mainImage?.url"
                                        [photoGalleryCaption]="
                                          prod
                                            ? prod.fullName +
                                              '<br>' +
                                              (prod.code ? ('product.code' | translate) + prod.code : '') +
                                              '<br>' +
                                              (prod.ean ? ' EAN: ' + prod.ean : '')
                                            : ''
                                        "
                                      >
                                        <div class="images-item">
                                          @if (!!prod.mainImage?.url?.length && !!prod.mainImage?.thumbnails?.length) {
                                            <img
                                              class="images-item-image"
                                              [src]="getThumbUrl(prod.mainImage)"
                                              [alt]="prod.fullName"
                                            />
                                          }
                                          @if (!prod.mainImage?.url?.length || !prod.mainImage?.thumbnails?.length) {
                                            <img
                                              class="images-item-image"
                                              [src]="'assets/img/no-image.png'"
                                              [alt]="prod.fullName"
                                            />
                                          }
                                        </div>
                                      </div>
                                      <div>
                                        <div>
                                          <a
                                            class="link-bold product-name-nowrap-wrapper"
                                            [routerLink]="['/product', prod.id]"
                                          >
                                            {{ prod ? prod.fullName : '' }}
                                          </a>
                                        </div>
                                        <div class="input-group-append flex-wrap product-center">
                                          @if (prod.code) {
                                            <div class="product-details">
                                              {{ 'product.code' | translate }}:<span
                                                [ngClass]="{ 'disabled-product': !prod.enabled }"
                                              >
                                                {{ prod.code }}</span
                                              >
                                            </div>
                                          }
                                          @if (prod.ean) {
                                            <div class="product-details">
                                              {{ 'product.ean' | translate }}:<span
                                                [ngClass]="{ 'disabled-product': !prod.enabled }"
                                              >
                                                {{ prod.ean }}</span
                                              >
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <modal-stock-overview
                                      class="availability-numbers-wrap"
                                      [isSumCalculated]="true"
                                      [isCalculatedOfProductDepots]="true"
                                      [isSmallBtn]="true"
                                      [product]="prod"
                                      [depots]="queryDepotsOptions.data()"
                                      [suppliers]="querySuppliers.data()"
                                      [filterDepotIdFrom]="
                                        selectedOperationType === 'out' || selectedOperationType === 'transfer'
                                          ? selectedDepotFrom()
                                          : selectedDepotTo
                                      "
                                    >
                                    </modal-stock-overview>
                                  </td>
                                  <td class="pe-1">
                                    <div class="flex-gap-10 align-items-center">
                                      <div>
                                        <modal-stock-operation-card
                                          [moves]="operations"
                                          [(movesOriginPositions)]="movesOriginPositions"
                                          [product]="prod"
                                          [depotFrom]="selectedDepotFrom()"
                                          [depotTo]="selectedDepotTo"
                                          [type]="selectedOperationType"
                                          [producers]="queryProducers.data()"
                                          [vats]="queryVats.data()"
                                          [suppliers]="querySuppliers.data()"
                                          [depots]="queryDepotsOptions.data()"
                                          [initDateDUZP]="initDateDUZP"
                                          (openModalSerialNumbers)="openModalSerialNumbers($event)"
                                          (result)="operationListChange($event)"
                                          [dataCyAttribute]="'operation-card'"
                                        >
                                        </modal-stock-operation-card>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          }
                        </div>
                      }
                    </table>
                  </div>
                </div>
              </div>
            }
            @if (selectedOperationType === 'transfer' && selectedDepotFrom() && products()?.length) {
              <div class="row prod-list-scrolling">
                <div class="col">
                  <div class="tableWrapper">
                    <table
                      class="table table-responsive"
                      [ngClass]="{ h150: !products()?.length && areCoreDataLoading() }"
                    >
                      <loading-spinner
                        [isLoading]="areCoreDataLoading() && (!!searchFulltext?.length || currentPage === 1)"
                        [classesString]="'pt-6'"
                      ></loading-spinner>
                      <div>
                        <thead>
                          <tr>
                            <th class="ps-0">{{ 'product.name' | translate }}</th>
                            <th class="text-center fixed-column-width">{{ 'position' | translate }}</th>
                            <th class="text-center fixed-column-width">
                              {{ ('product.expirationDate' | translate) + ', ' + ('product.batch' | translate) }}
                            </th>
                            <th class="text-center fixed-column-width">{{ 'products.availability' | translate }}</th>
                            <th class="fixed-column-width"></th>
                          </tr>
                        </thead>
                        <tbody class="images" [photoGalleryGroup]="{ index: 1 }">
                          @for (prod of products(); track prod) {
                            @for (pDepot of getProductDepotsWithQuantity(prod); track pDepot) {
                              <tr>
                                <td class="ps-1 custom-product-td" [ngClass]="{ 'disabled-product': !prod.enabled }">
                                  <div class="flex-gap-10 align-items-center">
                                    <div
                                      [photoGallery]="prod.mainImage?.url"
                                      [photoGalleryCaption]="
                                        prod
                                          ? prod.fullName +
                                            '<br>' +
                                            (prod.code ? ('product.code' | translate) + prod.code : '') +
                                            '<br>' +
                                            (prod.ean ? ' EAN: ' + prod.ean : '')
                                          : ''
                                      "
                                    >
                                      <div class="images-item">
                                        @if (!!prod.mainImage?.url?.length && !!prod.mainImage?.thumbnails?.length) {
                                          <img
                                            class="images-item-image"
                                            [src]="getThumbUrl(prod.mainImage)"
                                            [alt]="prod.fullName"
                                          />
                                        }
                                        @if (!prod.mainImage?.url?.length || !prod.mainImage?.thumbnails?.length) {
                                          <img
                                            class="images-item-image"
                                            [src]="'assets/img/no-image.png'"
                                            [alt]="prod.fullName"
                                          />
                                        }
                                      </div>
                                    </div>
                                    <div>
                                      <div>
                                        <a
                                          class="link-bold product-name-nowrap-wrapper"
                                          [routerLink]="['/product', prod.id]"
                                        >
                                          {{ prod ? prod.fullName : '' }}
                                        </a>
                                      </div>
                                      <div class="input-group-append flex-wrap product-center">
                                        @if (prod.code) {
                                          <div class="product-details">
                                            {{ 'product.code' | translate }}:<span
                                              [ngClass]="{ 'disabled-product': !prod.enabled }"
                                            >
                                              {{ prod.code }}</span
                                            >
                                          </div>
                                        }
                                        @if (prod.ean) {
                                          <div class="product-details">
                                            {{ 'product.ean' | translate }}:<span
                                              [ngClass]="{ 'disabled-product': !prod.enabled }"
                                            >
                                              {{ prod.ean }}</span
                                            >
                                          </div>
                                        }
                                        @if (pDepot.supplier?.id) {
                                          <div class="product-details">
                                            {{ 'product.supplier' | translate }}:<span
                                              [ngClass]="{ 'disabled-product': !prod.enabled }"
                                            >
                                              {{ pDepot.supplier.name }}</span
                                            >
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td class="text-center text-nowrap fixed-column-width">
                                  {{ pDepot.position }}
                                </td>
                                <td class="text-center">
                                  <div>
                                    {{ pDepot.expirationDate | fmtDate: 'dd.MM.yyyy' }}
                                  </div>
                                  <div>
                                    {{ pDepot.batch }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  {{ pDepot.quantityStock | number: '1.0-2' | replaceCommaToDot }}
                                </td>
                                <td class="pe-1">
                                  <div class="flex-gap-10 align-items-center">
                                    <div>
                                      <!--                            přidat input že to bude prodDepot a ne product:/-->
                                      <modal-stock-operation-card
                                        [product]="prod"
                                        [productDepot]="pDepot"
                                        [depotFrom]="selectedDepotFrom()"
                                        [depotTo]="selectedDepotTo"
                                        [type]="'transfer'"
                                        [producers]="queryProducers.data()"
                                        [vats]="queryVats.data()"
                                        [suppliers]="querySuppliers.data()"
                                        [depots]="queryDepotsOptions.data()"
                                        [initDateDUZP]="initDateDUZP"
                                        [isCreatingProduct]="false"
                                        [moves]="operations"
                                        [(movesOriginPositions)]="movesOriginPositions"
                                        [depotQuantity]="pDepot.quantityStock"
                                        (result)="operationListChange($event)"
                                        [dataCyAttribute]="'operation-card'"
                                      >
                                      </modal-stock-operation-card>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            }
                          }
                        </tbody>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            }
            @if (nextButtonShow() && !loadingFirstPage() && !(selectedOperationType !== 'in' && !selectedDepotFrom())) {
              <app-pagination-btn (switchPage)="queryProducts.fetchNextPage()" [loadingPage]="loadingNextPage()">
              </app-pagination-btn>
            }
          </div>
        }
        @if (isPrintingEANs) {
          <div class="row">
            <div class="col-12">
              <!--            <barcode-list-print-array [operations]="operations"></barcode-list-print-array>-->
              <print-code
                #printCodeComponent
                [productMovePack]="{ moves: operations }"
                [doRecalculateArray]="false"
                [labelPriceSource]="'purchase'"
                [labelCurrency]="selectedOperationType === 'out' ? core.services.user?.user?.company?.currency : null"
              ></print-code>
            </div>
          </div>
        }
      </div>

      <div
        class="col-12 col-sm-12 col-1100 pe-0"
        [ngClass]="{ 'col-lg-6': !isPrintingEANs, 'col-xl-6': !isPrintingEANs }"
      >
        <div class="card mb-0">
          <div class="flex-row">
            @if (isPrintingEANs) {
              <btn
                [label]="'select.invert'"
                [title]="'select.invert' | translate"
                [icon]="'far-exchange'"
                [classes]="['btn-third', 'float-right', 'me-2']"
                (onEvent)="printingSelect('invert')"
              ></btn>
            }
            @if (isPrintingEANs) {
              <btn
                [label]="'select.none'"
                [title]="'select.none' | translate"
                [icon]="'far-square'"
                [classes]="['btn-third', 'float-right', 'me-2']"
                (onEvent)="printingSelect('none')"
              ></btn>
            }
            @if (isPrintingEANs) {
              <btn
                [label]="'select.all'"
                [title]="'select.all' | translate"
                [icon]="'far-check-square'"
                [classes]="['btn-third', 'float-right', 'me-2']"
                (onEvent)="printingSelect('all')"
              ></btn>
            }
          </div>
          @if (!isPrintingEANs) {
            <div class="row">
              <div class="col d-flex align-self-center">
                @if (selectedOperationType === 'in') {
                  <div class="card-title text-nowrap" data-cy="batch-title">
                    {{ 'stock.load.list' | translate }}
                  </div>
                }
                @if (selectedOperationType === 'out') {
                  <div class="card-title" data-cy="batch-title">
                    {{ 'stock.unload.list' | translate }}
                  </div>
                }
                @if (selectedOperationType === 'transfer') {
                  <div class="card-title" data-cy="batch-title">
                    {{ 'stock.transfer.list' | translate }}
                  </div>
                }
              </div>
              <div class="col mt-md-1 d-flex justify-content-end">
                @if (!isPrintingEANs && operations?.length) {
                  <btn
                    [label]="'clear.options'"
                    [title]="'clear.options' | translate"
                    [icon]="'far-trash-alt'"
                    [classes]="['btn-first-red', 'btn-sm', 'me-2']"
                    (onEvent)="clearList()"
                    data-cy="cancel-stock"
                  ></btn>
                }
                @if (operations?.length) {
                  <btn
                    [label]="'print'"
                    [title]="'print' | translate"
                    [icon]="'far-print'"
                    [classes]="['btn-third', 'btn-sm', 'me-2']"
                    (onEvent)="printList()"
                    data-cy="print-products"
                  ></btn>
                }
                @if (!isPrintingEANs && selectedOperationType === 'in') {
                  <modal-batch-import-from-file
                    [depotTo]="selectedDepotTo"
                    [suppliers]="querySuppliers.data()"
                    (resultBatch)="importBatchFromFile($event)"
                  ></modal-batch-import-from-file>
                }
              </div>
            </div>
          }
          <form-row-input [label]="'duzp'" [inputType]="'date'" [(model)]="initDateDUZP"></form-row-input>
          @if (!operations?.length) {
            <div style="text-align: center; padding: 1.625rem">
              <div class="empty-list">
                <i class="far fa-sad-tear"></i>
                <div>
                  {{ 'empty.list' | translate }}
                </div>
              </div>
            </div>
          }
          @if (operations?.length) {
            <div class="table-responsive no-print" [ngClass]="{ 'scrollable-list-short': isPrintingEANs }">
              <table class="width-fill-available m-0">
                <thead>
                  <tr>
                    @if (isPrintingEANs) {
                      <th class="text-align-center padding-right-05">
                        {{ 'product.printEAN' | translate }}
                      </th>
                    }
                    <th>{{ 'product.name' | translate }}</th>
                    <th class="text-center fixed-column-width">
                      {{ ('product.expirationDate' | translate) + ', ' + ('product.batch' | translate) }}
                    </th>
                    <th class="padding-right-05 text-align-center">{{ 'position' | translate }}</th>
                    <th class="padding-right-05 text-align-center text-center">{{ 'quantity' | translate }}</th>
                    <th>
                      {{ 'purchasePrice' | translate }}
                    </th>
                    @if (!isPrintingEANs) {
                      <th>&nbsp;</th>
                    }
                    @if (!isPrintingEANs) {
                      <th>&nbsp;</th>
                    }
                  </tr>
                </thead>
                @if (selectedOperationType !== 'out') {
                  <tbody>
                    @for (operation of operations; track operation) {
                      <tr>
                        @if (isPrintingEANs) {
                          <td class="text-align-center">
                            <input
                              type="checkbox"
                              [(ngModel)]="operation.isEANPrintable"
                              (change)="refreshOperationsHack()"
                            />
                          </td>
                        }
                        @if (operation.product) {
                          <td>
                            <div class="flex-gap-10 align-items-center">
                              <product-image [product]="operation.product"></product-image>
                              <div>
                                <a
                                  class="link-bold align-self-center"
                                  [routerLink]="['/product', operation.product.id]"
                                >
                                  {{ operation.product ? operation.product.fullName : '' }}
                                </a>
                                <div class="flex-column-gap-10 flex-wrap flex-direction-row">
                                  @if (selectedOperationType === 'out' && operation.product.supplier) {
                                    <div class="flex-gap-5 flex-wrap product-details">
                                      {{ ('supplier' | translate) + ': ' + operation.product.supplier.name }}
                                    </div>
                                  }
                                  @if (operation.product.code) {
                                    <div class="flex-gap-5 flex-wrap product-details">
                                      {{ ('product.code' | translate) + ': ' + operation.product.code }}
                                    </div>
                                  }
                                  @if (operation.product.ean) {
                                    <div class="flex-gap-5 flex-wrap product-details">
                                      {{ ('product.ean' | translate) + ': ' + operation.product.ean }}
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                        }
                        <td>
                          <div class="text-center">
                            {{ operation.expirationDate | fmtDate: 'dd.MM.yyyy' }}
                          </div>
                          <div class="text-center">
                            {{ operation.batch }}
                          </div>
                        </td>
                        <td class="width-max-content text-nowrap text-center">
                          @if (selectedOperationType === 'transfer') {
                            <div class="strikethrough">
                              {{ getOperationsOriginPosition(operation) }}
                            </div>
                          }
                          <div>
                            {{
                              operation.position1 || operation.position2 || operation.position3
                                ? (operation.position1 ? operation.position1 : '') +
                                  '-' +
                                  (operation.position2 ? operation.position2 : '') +
                                  '-' +
                                  (operation.position3 ? operation.position3 : '')
                                : ''
                            }}
                          </div>
                        </td>
                        <td class="width-max-content text-nowrap text-end">
                          {{ (operation.amount | number: '1.0-2' | replaceCommaToDot) || 0 }}
                        </td>
                        <td class="width-max-content text-nowrap text-end">
                          {{ operation.purchasePrice | formatPrice: { id: operation.purchaseCurrency } }}
                        </td>
                        @if (!isPrintingEANs) {
                          <td class="pe-1 width-max-content">
                            <div class="flex-gap-5 align-self-center float-right">
                              <btn
                                class="d-flex align-items-center"
                                [title]="'delete' | translate"
                                [icon]="'far-trash-alt'"
                                (onEvent)="removeOperation(operation)"
                                [classes]="['btn-sm', 'btn-trash']"
                              >
                              </btn>
                              <modal-stock-operation-card
                                class="d-flex align-items-center"
                                [operationToUpdate]="operation"
                                [product]="operation.product"
                                [productDepot]="operation.productDepotFrom"
                                [depotFrom]="selectedDepotFrom()"
                                [depotTo]="selectedDepotTo"
                                [type]="selectedOperationType"
                                [producers]="queryProducers.data()"
                                [vats]="queryVats.data()"
                                [suppliers]="querySuppliers.data()"
                                [depots]="queryDepotsOptions.data()"
                                (openModalSerialNumbers)="openModalSerialNumbers($event)"
                                (operationUpdated)="updateOperation($event)"
                                [dataCyAttribute]="'edit-operation-card'"
                              >
                              </modal-stock-operation-card>
                            </div>
                          </td>
                        }
                        @if (!isPrintingEANs) {
                          <td>
                            @if (operation.product?.requiredSerialNumbers && selectedOperationType !== 'transfer') {
                              <app-modal-serial-numbers
                                #modalSerialNumbers
                                [productMove]="operation"
                                [isCreatingProductMovePack]="true"
                                (serialNumbersChanged)="persistSerialNumbersDraft(operation, $event)"
                                (serialNumbersEdited)="persistSerialNumbersDraft(operation, $event)"
                              >
                              </app-modal-serial-numbers>
                            }
                          </td>
                        }
                      </tr>
                    }
                    @if (operations?.length && !isPrintingEANs) {
                      <tr>
                        <td class="no-hover">
                          <strong>{{ 'sum' | translate }}</strong>
                        </td>
                        <td class="no-hover">&nbsp;</td>
                        <td class="no-hover text-start">&nbsp;</td>
                        <td class="text-end text-nowrap no-hover">
                          <div class="flex-gap-10 justify-content-end">
                            <strong>{{ 'bill.quantity' | translate }}: {{ operations | listLength }}</strong>
                            <strong>/</strong>
                            <strong
                              >{{ 'bill.amount' | translate }}:
                              {{ operations | operationsPriceSum: ['quantity'] }}</strong
                            >
                          </div>
                        </td>
                        <td class="text-end text-nowrap no-hover">
                          <strong>{{ operations | operationsPriceSum: ['purchase'] | formatPrice }}</strong>
                        </td>
                        <td class="no-hover">&nbsp;</td>
                      </tr>
                    }
                  </tbody>
                }
                @if (selectedOperationType === 'out') {
                  <tbody>
                    @for (operation of operations; track operation) {
                      <tr>
                        @if (isPrintingEANs) {
                          <td class="text-align-center">
                            <input
                              type="checkbox"
                              [(ngModel)]="operation.isEANPrintable"
                              (change)="refreshOperationsHack()"
                            />
                          </td>
                        }
                        @if (operation.product) {
                          <td class="flex-gap-10 align-items-center">
                            <product-image [product]="operation.product"></product-image>
                            <div>
                              <a class="link-bold align-self-center" [routerLink]="['/product', operation.product.id]">
                                {{ operation.product ? operation.product.fullName : '' }}
                              </a>
                              <div class="flex-column-gap-10 flex-wrap flex-direction-row">
                                @if (operation.product.code) {
                                  <div class="flex-gap-5 flex-wrap product-details">
                                    {{ ('product.code' | translate) + ': ' + operation.product.code }}
                                  </div>
                                }
                                @if (operation.product.ean) {
                                  <div class="flex-gap-5 flex-wrap product-details">
                                    {{ ('product.ean' | translate) + ': ' + operation.product.ean }}
                                  </div>
                                }
                              </div>
                            </div>
                          </td>
                        }
                        <td>
                          <div class="text-center">
                            {{ operation.expirationDate | fmtDate: 'dd.MM.yyyy' }}
                          </div>
                          <div class="text-center">
                            {{ operation.batch }}
                          </div>
                        </td>
                        <td class="width-max-content text-nowrap text-center">
                          {{
                            operation.position1 || operation.position2 || operation.position3
                              ? (operation.position1 ? operation.position1 : '') +
                                '-' +
                                (operation.position2 ? operation.position2 : '') +
                                '-' +
                                (operation.position3 ? operation.position3 : '')
                              : ''
                          }}
                        </td>
                        <td class="width-max-content text-nowrap text-end">
                          {{ (operation.amount | number: '1.0-2' | replaceCommaToDot) || 0 }}
                        </td>
                        <td class="width-max-content text-nowrap text-end">
                          {{ operation.purchasePrice | formatPrice }}
                        </td>
                        @if (!isPrintingEANs) {
                          <td class="pe-1 width-max-content">
                            <div class="flex-gap-5 align-self-center float-right">
                              <btn
                                class="d-flex align-items-center"
                                [title]="'delete' | translate"
                                [icon]="'far-trash-alt'"
                                (onEvent)="removeOperation(operation)"
                                [classes]="['btn-sm', 'btn-trash']"
                              >
                              </btn>
                              @if (operation.product?.requiredSerialNumbers && selectedOperationType !== 'transfer') {
                                <app-modal-serial-numbers
                                  #modalSerialNumbers
                                  [productMove]="operation"
                                  [isCreatingProductMovePack]="true"
                                  (serialNumbersChanged)="persistSerialNumbersDraft(operation, $event)"
                                  (serialNumbersEdited)="persistSerialNumbersDraft(operation, $event)"
                                >
                                </app-modal-serial-numbers>
                              }
                            </div>
                          </td>
                        }
                      </tr>
                    }
                    @if (operations?.length && !isPrintingEANs) {
                      <tr>
                        <td class="no-hover">
                          <strong>{{ 'sum' | translate }}</strong>
                        </td>
                        <td class="no-hover">&nbsp;</td>
                        <td class="no-hover">&nbsp;</td>
                        <td class="text-nowrap no-hover text-end">
                          <div class="flex-gap-10 justify-content-end">
                            <strong>{{ 'bill.quantity' | translate }}: {{ operations | listLength }}</strong>
                            <strong>/</strong>
                            <strong
                              >{{ 'bill.amount' | translate }}:
                              {{ operations | operationsPriceSum: ['quantity'] }}</strong
                            >
                          </div>
                        </td>
                        <td class="text-end text-nowrap no-hover">
                          <strong>{{ operations | operationsPriceSum: ['purchase'] | formatPrice }}</strong>
                        </td>
                        <td class="no-hover">&nbsp;</td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
          }

          @if (!isPrintingEANs) {
            <div class="mt-2">
              <div class="col-12 ps-0 pe-0">
                <div class="operation-list mt-2 advanced">
                  <div class="row">
                    <div class="col-12">
                      <div class="operation-card">
                        <form-row-input
                          [label]="'externalReference'"
                          [icon]="null"
                          [model]="externalReference"
                          (modelChange)="updateExternalReference($event)"
                          [dataCyAttribute]="'stock-external reference'"
                        ></form-row-input>
                        <!--                      todo to cypress test -> input external reference-->
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="operation-card">
                        <form-row-textarea
                          [label]="'note'"
                          [icon]="null"
                          [model]="note"
                          (modelChange)="updateNote($event)"
                          [dataCyAttribute]="'stock-note'"
                        ></form-row-textarea>
                      </div>
                    </div>
                  </div>
                  <div class="operation-card mt-2">
                    @if (uploadedFiles?.length) {
                      <div class="row">
                        <div class="col-12 pe-0">
                          <div class="table-responsive">
                            <table class="w-100">
                              <tbody>
                                @for (f of uploadedFiles; track f) {
                                  <tr>
                                    <td class="ps-1">
                                      <div class="flex-gap-10">
                                        @if (f.mimeType?.includes('image/')) {
                                          <i class="fa fa-file-image" title="Image"></i>
                                        }
                                        @if (
                                          f.mimeType?.includes('text/') ||
                                          f.mimeType?.includes('/msword') ||
                                          f.mimeType?.includes('wordprocessingml')
                                        ) {
                                          <i class="fa fa-file-text" title="Text"></i>
                                        }
                                        @if (f.mimeType?.includes('application/pdf')) {
                                          <i class="fa fa-file-pdf" title="Pdf"></i>
                                        }
                                        @if (f.mimeType?.includes('spreadsheet') || f.mimeType?.includes('ms-excel')) {
                                          <i class="fa fa-file-excel" title="Excel"></i>
                                        }
                                        @if (unknownType(f.mimeType)) {
                                          <i class="fa fa-file" title="File"></i>
                                        }
                                        <a class="link" href="{{ f.url }}" target="_blank">
                                          {{ f.originalFilename || f.text || 'file' }}
                                        </a>
                                      </div>
                                    </td>
                                    <td class="pe-1">
                                      <btn
                                        class="d-flex align-items-center"
                                        [title]="'delete' | translate"
                                        [icon]="'far-trash-alt'"
                                        [classes]="['btn-trash', 'btn-sm', 'float-right']"
                                        (onEvent)="removeUploadedFile(f)"
                                      ></btn>
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    }
                    <div class="row">
                      <div class="col-12 mt-2">
                        <loading-spinner [isLoading]="areFilesUploading" [classesString]="'top-25'"></loading-spinner>
                        <form-row-input
                          [label]="'files'"
                          [icon]="'far-upload'"
                          [inputType]="'file'"
                          [inputMultiple]="true"
                          (valueChangeNative)="uploadFiles($event)"
                        ></form-row-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
